import { BackIcon } from 'assets/icons';
import { CustomButton, CustomTextArea } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { termsMaxCount } from 'containers/settings/constants';
import { FC, useState } from 'react';

interface EditEstimateTncPanelProps {
  tnc: string;
  onBackClick: () => void;
  onSave: (tnc: string) => void;
}

const EditEstimateTncPanel: FC<EditEstimateTncPanelProps> = ({ tnc, onBackClick, onSave }) => {
  const [estimateTnc, setEstimateTnc] = useState(tnc);

  const onSaveClick = () => {
    onSave(estimateTnc.trim());
  };

  return (
    <div className="h-full w-96">
      <div className="mb-1 flex items-center border-b border-secondaryBtn py-4">
        <BackIcon className="mx-4 cursor-pointer" id="estimate-details-panel-back-arrow" onClick={onBackClick} />
        <div className="text-17px font-semibold text-headingGray">Terms & Conditions</div>
      </div>
      <div className="py-6 px-4">
        <CustomTextArea
          id="edit-estimate-tnc"
          name="edit-estimate-tnc"
          placeholder="Enter terms & conditions"
          className="h-[140px] max-h-[140px] rounded-md border border-borderGray bg-transparent font-semibold 
                    text-primaryText focus:outline-none"
          value={estimateTnc}
          onChange={setEstimateTnc}
          maxLength={termsMaxCount}
          showRemainingChar={true}
        />
      </div>
      <div className="flex w-full flex-col gap-y-4 p-4 pt-0">
        <CustomButton
          id="edit-estimate-tnc-save-button"
          className="w-full"
          onClick={onSaveClick}
          type={ButtonType.PRIMARY}
          disabled={tnc.trim() === estimateTnc.trim()}>
          Save
        </CustomButton>
        <CustomButton
          id="edit-estimate-tnc-cancel-button"
          className="w-full"
          onClick={onBackClick}
          type={ButtonType.SECONDARY}>
          Cancel
        </CustomButton>
      </div>
    </div>
  );
};

export default EditEstimateTncPanel;
